<template>
  <div class="content" :class="{ 'isMobile': isMobile }">
    <div class="history-wrapper base-button">
      <div class="history-header">
        <div class="title">{{ robotName }}历史记录</div>
      </div>

      <div class="new-wrapper">
        <button type="primary" @click="newSessionClick(true)">新建对话</button>
      </div>
      <div class="dialog-wrapper">
        <ul>
          <template v-for="(chat, index) in conversations">
            <li v-show="chat.messages.length >= 3 || (robotId === 'composition' && chat.messages.length >= 2)"
              :class="chat.id === selectedSessionId ? 'chat-selected' : ''" @click="handleChangeChat(chat.id)">
              <div class="chat-name">
                <div v-if="!chat.isInput" @dblclick="editChatName(chat)">
                  <div class="cname">{{ chat.name }}</div>
                </div>
                <el-input required v-else size="mini" v-model="chat.name" @blur="handleBlur($event, chat)"></el-input>
              </div>
              <div class="chat-time">
                {{ getChatTime(chat.createdAt) }}
                <span class="del-btn" @click.stop="openDeleteDialog(chat.id, chat.name)"><i
                    class="el-icon-delete"></i></span>
              </div>
            </li>
          </template>
        </ul>
      </div>
      <div class="btn-wrapper">
        <button type="primary" class="delAll-btn" v-if="isShowAllDel" @click="allDialogVisible = true">一键删除</button>
      </div>
    </div>
    <div class="collapse-btn">
      <el-tooltip content="收起历史" placement="right">
        <div class="fold-area">
          <!-- <div class="fold" @click="fold"></div> -->
          <i class="el-icon-circle-close close-btn" @click="fold"></i>
        </div>
      </el-tooltip>
    </div>
    <el-dialog title="提示" :visible.sync="allDialogVisible" :append-to-body="true" class="delDialog" width="20%" top="15%">
      <span>确定删除{{ robots[robotId].name }}的所有会话记录吗？</span>
      <span slot="footer" class="dialog-footer base-button">
        <button @click="allDialogVisible = false" style="margin-right: 10px">取 消</button>
        <button type="primary" @click="deleteAllSession">确 定</button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="singleDialogVisible" :append-to-body="true" class="delDialog" width="20%" top="15%">
      <span>确定删除会话“{{ selectedName }}”吗？</span>
      <span slot="footer" class="dialog-footer base-button">
        <button @click="singleDialogVisible = false" style="margin-right: 10px">取 消</button>
        <button type="primary" @click="deleteSession">确 定</button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript" src="../../assets/mermaid/mermaid.min.js" async></script>
<script>
import store from "@/store/index";
import { mapState } from "vuex";
import chatMixin from "@/mixin/chat.js";
import * as sendReceiveApi from "@/api/chat/sendReceive";
import { isMobile } from "../../utils/deviceDetector";
export default {
  data() {
    return {
      keyword: "",
      dialogVisible: false,
      singleDialogVisible: false,
      allDialogVisible: false,
      selectedSessionId: "",
      selectedName: "",
    };
  },
  mounted(){

  },
  computed: {
   
    
    conversations() {
      return store.getters.conversationsByAiType(this.robotId)
    },
    robotName() {
      let robot = this.robots[this.robotId];
      if (robot) {
        return robot.nickName ? robot.nickName : robot.name;
      }
    },
    isShowAllDel() {
      
      if (this.conversations.length >= 1) {
        return true
      }
    
    },
    ...mapState([
      "robotSessionMap",
      "robotId",
      "sessionId",
      "robots",
      "foldHistory",
    ]),
  },
  mixins: [chatMixin],
  
  methods: {
    // ★ 删除全部会话后自动新建会话
    //   该智能体的会话已全部删除 → robotSessionMap 已被清为 null → 直接新建
    async autoCreateSessionAfterDelete(robotId) {
        try {
            // 确认该智能体确实无任何会话了（兜底校验）
            const convs = store.getters.conversationsByAiType(robotId) || [];
            if (convs.length > 0) {
                // 还有会话（理论上不会走到），激活最新的即可
                await store.dispatch('switchActiveConversation', convs[0].id);
                store.commit("setSessionId", convs[0].id);
                return;
            }

            // 同步当前智能体（mixin 的 newSession 内部依赖 store 的 robotId）
            store.commit("setRobotId", robotId);
            // 清掉残留的 sessionId，避免 newSession 拿到旧值
            store.commit("setSessionId", "");

            // 与刷新/切换行为保持一致：练习类智能体手动新建并拉取每日一题
            if (robotId === 'exercises' || robotId === 'mexercises') {
                await this.newSession('新会话', { manual: true });
            } else {
                await this.newSession('新会话');
            }
        } catch (error) {
            console.error('autoCreateSessionAfterDelete error:', error);
        }
    },

    fold() {
      store.commit("SET_FOLDHISTORY", !this.foldHistory);
    },
 

    handleBlur(e, chat) {
      if (!e.target.value || !e.target.value.trim()) {
        this.$message.error("会话名不能为空");
        return;
      }

      store.dispatch("updateConversationName",{
        conversationId: chat.id,
        newName: chat.name
      })
      this.$set(chat, 'isInput', !chat.isInput)
    },

    getChatTime(timeString) {
      const date = new Date(timeString);
      return date.toLocaleString();
    },
    async handleChangeChat(sessionId) {
      this.selectedSessionId = sessionId;

      // ★ 优先从数据库加载最新数据
      let targetConv = await store.dispatch('switchActiveConversation', sessionId);
      if (!targetConv) {
        // 若失败，尝试从内存中查找（兜底）
        targetConv = this.conversations.find(conv => conv.id === sessionId);
        if (targetConv) {
          store.commit('setActiveConversation', targetConv);
        }
      }

      store.commit("SET_ROBOTSESSIONMAP", { robotId: this.robotId, sessionId });
      // 路由跳转时使用完整 ID（已改）
      this.$router.push(`/chatSearch/${this.robotId}/${sessionId.slice(-10)}`);
      if (this.isMobile) store.commit("SET_FOLDHISTORY", true);
    },
    editChatName(chat) {
      // chat.isInput = !chat.isInput
      this.$set(chat, 'isInput', !chat.isInput)
    },
    handleNewChat() { },
    openDeleteDialog(id, name) {
      this.selectedSessionId = id;
      this.selectedName = name;
      this.singleDialogVisible = true;
      return false;
    },
    async deleteAllSession() {
        // ★ 删除前记录当前智能体，防止删除过程中状态变化
        const robotId = this.robotId;
        const sessionIds = this.conversations
            .filter(conv => conv.aiType === robotId)
            .map(conv => conv.id);

        // 没有可删除的会话，直接返回
        if (sessionIds.length === 0) {
            this.allDialogVisible = false;
            return;
        }

        let { data } = await sendReceiveApi.delSession({
            sessionId: sessionIds,
        });
        this.allDialogVisible = false;
        if (data && data.message.includes("成功")) {
            await store.dispatch("deleteConversation", sessionIds)
            this.$message.success("删除成功");

            // ★★★ 新增：删除后自动建立新会话
            await this.autoCreateSessionAfterDelete(robotId);
        } else {
            this.$message.error("删除失败");
        }
    },
    async deleteSession() {
        let { data } = await sendReceiveApi.delSession({
            sessionId: [this.selectedSessionId],
        });
        this.singleDialogVisible = false;
        if (data && data.message.includes("成功")) {
            this.$message.success("删除成功");
            const deletedId = this.selectedSessionId;   // ★ 先记下，dispatch 后 selectedSessionId 不变但其实可读
            await store.dispatch("deleteConversation", deletedId);

            // ★ 新增：删的是当前激活会话 → 激活该智能体剩余最新会话，没有则新建
            if (this.sessionId === deletedId) {
                const convs = store.getters.conversationsByAiType(this.robotId) || [];
                if (convs.length > 0) {
                    await store.dispatch('switchActiveConversation', convs[0].id);
                    store.commit("setSessionId", convs[0].id);
                    store.commit("SET_ROBOTSESSIONMAP", { robotId: this.robotId, sessionId: convs[0].id });
                    this.$router.replace(`/chatSearch/${this.robotId}/${convs[0].id.slice(-10)}`);
                } else {
                    await this.autoCreateSessionAfterDelete(this.robotId);
                }
            }
        } else {
            this.$message.error("删除失败");
        }
    },
  },
  watch: {
    sessionId: {
      immediate: true,
      async handler(newVal) {
       this.selectedSessionId = newVal
      },
    },

  }


};
</script>
<style scoped lang="scss">
.content {
  height: 100vh;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: var(--leftbox-bg-color);
  width: 100%;
}

.collapse-btn {
  position: absolute;
  bottom: 44px;
  left: calc(var(--robot-width) + var(--history-width) - 29px);
  width: 28px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.fold-area {
  width: 28px;
  height: 28px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--leftbox-bg-color);

  &:hover {
    background-color: #f1f2f4;
  }

  .fold {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAQlBMVEVHcExPWGZQWWZQWGVQWGZQWGBQWGhQWGZQWGRPWGdQUGBPWWZOWGZQUHBQV2ZQWmVQYGBQVWVOV2VQWGVQV2VPWGZTvtamAAAAFXRSTlMA33BgfyAggEDfEO+AEHAwEDCwv5Bf+ekOAAAAwklEQVRIx+3WzQ7CIBAE4AKllOK/7vu/qrbUm51JRhM1Yc77XWCZ0HUtP5lzlGl0Zl7FwcyKitMDW8MfxtOo497MTSLu5xGv4cVakHC1eVAwsgxDSzC2GBMLMbMIUwswt9s4LraE8WUixjeD8RBfMS4QXzDOECeMdxAPdWjjwPbkqg4LdlGroUQ1Wk+q4cNgGj9JokkZYM1qCGpagKsWezvZG71dR4KI5xmtt+ueH9vP4M+xfzahklNem1DL2oQtX8odsComt3l8hQAAAAAASUVORK5CYII=);
    background-repeat: no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
  }

  .close-btn {
    font-size: $font_icon_size;
    font-weight: 600;
    color: var(--txt-default-color);
    opacity: .8;

    &:hover {
      color: var(--txt-color-blue);
    }
  }
}

.history-wrapper {
  flex: 1;
  background-color: var(--leftbox-bg-color);

  .history-header {
    position: relative;
    padding: 15px 0 0;
    display: flex;
    justify-content: center;

    .title {
      margin: 0;
      margin-bottom: 15px;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 38px;
    }

  }

  .new-wrapper {
    margin: 3px 12px 20px;
    text-align: center;

    button {
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      border-radius: 24px;
    }
  }

  .btn-wrapper {
    margin: 1rem 0.6rem;
    text-align: center;

    .delAll-btn {
      border-radius: 24px;
      font-weight: 600;
    }
  }

  .dialog-wrapper {
    max-height: calc(100vh - 190px);
    overflow-y: auto;

    ul {
      margin: 0;
      list-style: none;
      padding: 0;

      li {
        font-size: 14px;
        margin-right: 5px;
        padding: 10px 10px;

        &:hover {
          border-left: 2px solid $base_green;
          box-shadow: 0 0 6px 0 rgba(113, 127, 167, 0.28);
          background-color: var(--session-bg-color, #2b2e30);

          .chat-name .cname {
            color: $base_green;
          }
        }

        .del-btn {
          float: right;

          &:hover {
            color: red;
          }
        }
      }

      .chat-selected {
        box-shadow: 0 0 6px 0 rgba(113, 127, 167, 0.28);
        background-color: var(--session-bg-color, #2b2e30);
        ;
        border-left: 2px solid $base_green;

        .chat-name .cname {
          color: $base_green;
        }
      }
    }


    .chat-name .cname,
    .chat-name input,
    .chat-time {
      font-size: 14px;
      font-weight: 400;
      color: #666;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      cursor: pointer;
      line-height: 1.5rem;
    }

  }
}

@media (max-width: 1023px) {
  ::v-deep .el-dialog {
    margin-top: 30vh !important;
    width: 90% !important;
  }

  .collapse-btn {
    position: absolute;
    display: inline-block;
    width: fit-content;
    position: absolute;
    right: 0.2rem;
    top: 0.1rem;
    z-index: 1001;
    padding-bottom: 0;


  }

}

.fold-area {
  background-color: var(--main-color, rgba(79, 88, 102, .08)) !important;
}

.isMobile {

  font-size: 0.3rem;

  .dialog-wrapper {
    max-height: 61vh !important;
    overflow-y: scroll;
  }

  .new-wrapper {
    margin-top: 2vh;
    margin: 0 0.2rem 0.2rem;
    text-align: center;

    button {
      font-size: $font_size;
      height: 0.8rem;
      line-height: 0.24rem;
      width: 80%;
    }
  }

  .btn-wrapper {
    margin: 20px 0;
  }

  .chat-time,
  .cname {
    line-height: 1.3 !important;
  }

  .content {
    height: 100%;

    .collapse-btn {
      background-color: var(--bg-color-3);
      border-radius: 50%;
      height: fit-content;
    }

    .collapse-btn {
      justify-content: center;

      .fold {
        width: 0.36rem;
        height: 0.36rem;
      }
    }

  }
}
</style>